import React from "react";
import PremiumQuoteResults from "./QuoteResultsPremium";

const coachResultsConfig = {
  brandName: "CheapCoachGrab",
  className: "premium-results-coach",
  funnelTrackingEnabled: true,
  chatBrand: "cheapcoachgrab",
  chatNudgeDisabled: true,
  bookingPath: "/coach-book",
  // Coach experiment switch. Change to true to restore the existing public
  // estimates without touching fare calculations or the enquiry flow.
  showPublicPricing: false,
  defaultVehicles: ["fourteen", "twentyfive"],
  forceVehicleSet: ["fourteen", "twentyfive"],
  forceRequestableVehicleCodes: ["fourteen"],
  forceEnquiryOnly: true,
  estimateDiscountPercent: 0,
  discountNudgeEnabled: false,
  enquiryIntentEnabled: true,
  cardSpecificEnquiryIntent: true,
  enquiryButtonLabel: "Get my coach quote",
  noPriceButtonLabel: "Get my coach quote",
  hideSecondaryAction: true,
  noPriceEyebrow: "Your coach price needs a quick check",
  noPriceLabel: "Get an accurate coach quote",
  noPriceSubtext: "Confirm passengers and luggage. We’ll compare available operators and send your fixed price.",
  resultsHeadline: "Coach options for your journey",
  resultsIntro:
    "To give you an accurate coach price, we confirm passenger numbers, luggage and operator availability. No payment or obligation.",
  additionalEnquiryCards: [
    {
      id: "multiple_vehicles",
      sourceVehicleCode: "twentyfive",
      detailsKey: "multiple",
      note: "Please compare suitable multiple-vehicle arrangements for this journey.",
      requestedOptions: ["multiple vehicle options"],
      details: {
        title: "Multiple Vehicle Options",
        subtitle: "Flexible combinations tailored to your group",
        image: "/coach-hero.png",
        badge: "Flexible group option",
        badgeTone: "green",
        passengers: "Flexible Capacity",
        bags: "Tailored Luggage",
        highlight: "Compare a coach with suitable minibus combinations",
        similar: "Final arrangement based on passengers, luggage and availability",
        bullets: ["30-second enquiry", "No payment today", "We’ll compare available partners"],
      },
    },
  ],
  inclusions: [
    "▱ No payment required today",
    "◴ Final vehicle and rate confirmed first",
    "▱ Support before and after booking",
  ],
  estimateDisclaimer:
    "Coach enquiries remain subject to final passenger count, luggage, stops, vehicle availability, driver/operator coverage and confirmation by our support team.",
  priorityTitle: "Coach journeys planned around your group",
  priorityBody:
    "Large group transfers are checked around airport timing, passenger loading, luggage and partner availability.",
  trustItems: [
    { icon: "★", title: "4.8 ★★★★★", body: "Google reviews", href: "https://share.google/trIAb3GAvw55L1l8S" },
    { icon: "♢", title: "Licensed Coach Partners", body: "Vetted & insured" },
    { icon: "♙", title: "10,000+ Successful Journeys", body: "Groups across the UK" },
    { icon: "☎", title: "24/7 Support", body: "Before and after booking" },
    { icon: "▣", title: "Secure & Trusted", body: "Your enquiry is safe" },
  ],
  vehicles: {
    fourteen: {
      title: "16 Seater Minibus / Mini Coach",
      subtitle: "Flexible choice for medium-sized groups",
      image: "/coach-hero.png",
      badge: "Up to 16 passengers",
      badgeTone: "green",
      passengers: "Up to 16 Passengers",
      bags: "16 Large Bags",
      highlight: "Useful for corporate groups, events and airport transfers",
      similar: "Mercedes Sprinter or similar",
      proof: "Available to request",
      bullets: ["30-second enquiry", "No payment today", "We’ll check available partners"],
    },
    twentyfive: {
      title: "25 Seater Coach",
      subtitle: "Coordinated coach hire for larger airport groups",
      image: "/coach-hero.png",
      badge: "Recommended for coach hire",
      badgeTone: "rose",
      passengers: "Up to 25 Passengers",
      bags: "Group Luggage",
      highlight: "Best for schools, teams, tours and company airport transfers",
      similar: "Executive mini coach or similar",
      proof: "Available to request",
      bullets: ["30-second enquiry", "No payment today", "We’ll check available partners"],
    },
  },
};

const QuoteResultscoach = () => <PremiumQuoteResults config={coachResultsConfig} />;

export default QuoteResultscoach;
